import { TransactionType, TransactionStatus } from '../../types/drawdown';

export function getTypeLabel(type: string): string {
  switch (type) {
    case TransactionType.DRAWDOWN:
      return 'Drawdown';
    case TransactionType.INVESTMENT_PURCHASE:
      return 'Investment';
    case TransactionType.FUND_FEE_EXPENSE:
      return 'Fee/Expense';
    case TransactionType.DISTRIBUTION:
      return 'Distribution';
    case TransactionType.LP_TRANSFER:
      return 'LP Transfer';
    case TransactionType.MANUAL_ADJUSTMENT:
      return 'Manual';
    case TransactionType.VALUATION_CHANGE:
      return 'Valuation';
    case TransactionType.ASSET_SALE:
      return 'Asset Sale';
    case TransactionType.MANAGER_CURRENT_ACCOUNT:
      return 'Manager current account';
    default:
      return type;
  }
}

export function getTypeLabelFull(type: string): string {
  switch (type) {
    case TransactionType.INVESTMENT_PURCHASE:
      return 'Investment Purchase';
    case TransactionType.VALUATION_CHANGE:
      return 'Valuation Change';
    case TransactionType.ASSET_SALE:
      return 'Asset Sale';
    default:
      return getTypeLabel(type);
  }
}

const DRAFT_STATUS = 'draft';

export function getStatusBadgeStyle(status: string): string {
  switch (status) {
    case DRAFT_STATUS:
      return 'bg-amber-50 text-amber-700 border-amber-200 dark:bg-amber-950 dark:text-amber-400 dark:border-amber-800';
    case TransactionStatus.APPROVED:
      return 'bg-blue-50 text-blue-700 border-blue-200 dark:bg-blue-950 dark:text-blue-400 dark:border-blue-800';
    case TransactionStatus.POSTED:
      return 'bg-green-50 text-green-700 border-green-200 dark:bg-green-950 dark:text-green-400 dark:border-green-800';
    case TransactionStatus.REVERSED:
      return 'bg-red-50 text-red-700 border-red-200 dark:bg-red-950 dark:text-red-400 dark:border-red-800';
    default:
      return 'bg-muted text-muted-foreground border-border';
  }
}

export function getStatusLabel(status: string): string {
  switch (status) {
    case DRAFT_STATUS:
      return 'Draft';
    case TransactionStatus.APPROVED:
      return 'Approved';
    case TransactionStatus.POSTED:
      return 'Posted';
    case TransactionStatus.REVERSED:
      return 'Reversed';
    default:
      return status;
  }
}
